import { HTMLAttributes, ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { Heading } from '../../../../../Heading/Heading';

interface CatchDetailsSectionProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  className?: string;
  title?: string;
}

export const CatchDetailsSection = ({
  children,
  className,
  title,
  ...rest
}: CatchDetailsSectionProps) => {
  return (
    <section className={twMerge('mb-6', className)} {...rest}>
      {title && (
        <Heading className="mb-4" variant="2xs">
          {title}
        </Heading>
      )}
      {children}
    </section>
  );
};
